import { useTranslations } from '@lang';
import { useMemo } from 'react';
import { ItineraryDrawerTemplate } from 'voyager';
import { usePackageItinerary } from '../../hooks/usePackageItinerary';

type PackageItineraryProps = {
  open: boolean;
  onClose: () => void;
};

export const PackageItinerary = ({ open, onClose }: PackageItineraryProps) => {
  const { t } = useTranslations();
  const { guests, stay } = usePackageItinerary();

  const labels = useMemo(
    () => ({
      title: t('package.itinerary.title'),
      closeLabel: t('package.itinerary.close'),
      continueLabel: t('package.itinerary.continuePlanning'),
      selectGuestLabel: t('basket.selectGuestLabel'),
    }),
    [t]
  );

  return (
    <ItineraryDrawerTemplate
      open={open}
      onClose={onClose}
      guests={guests}
      stay={stay}
      labels={labels}
    />
  );
};
